var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.505475 25.5501C0.892622 25.8948 1.49747 25.8827 1.82798 25.5155L1.83234 25.5107L1.83242 25.5107L9.73878 17.2829L9.88258 17.1332L10.0268 17.2825L17.932 25.463C18.1319 25.6624 18.3583 25.7708 18.6161 25.771L18.6161 25.7708C19.0942 25.7708 19.5228 25.3629 19.5653 24.8144V1.14942C19.5653 0.616264 19.1493 0.200231 18.6161 0.200231L1.14919 0.2L0.505475 25.5501ZM0.505475 25.5501C0.323169 25.3659 0.242811 25.1434 0.2 24.8969V1.14919C0.2 0.616001 0.616031 0.200001 1.14919 0.2L0.505475 25.5501ZM2.44236 22.1565L9.19775 15.1252C9.39491 14.929 9.66645 14.8173 9.88263 14.8173H9.88299C10.1409 14.8173 10.3676 14.9257 10.5676 15.1251L17.323 22.1565L17.6672 22.5148V22.0179V2.29815V2.09815H17.4672H2.29813H2.09813V2.29815V22.0179V22.5148L2.44236 22.1565Z",
    fill: "#42A460",
    stroke: "#EDF6F0",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.442e188bc7824e3ef3e466ea15da537d.svg";
export { ForwardRef as ReactComponent };